import { create } from '@bufbuild/protobuf'
import { t } from 'i18next'

import { SimulateOrdersResponse } from '@enechain/eposition-proto/bffportal/v1/simulation_service_pb'
import {
  StatusLabel,
  StatusLabelSchema,
  StatusLabel_Status,
} from '@enechain/eposition-proto/bfftypes/v1/label_pb'

export type ResultSimulationForOption1Model = {
  relationNumber: string
  orderRelationString: string
  allowDeal: boolean
  allowDealStatus: StatusLabel
  requiredMarginAmount: string
  surplusAmount: string
  collateralAmount: string
  totalCreditAmount: string
}

export function convertResultSimulationForOption1Model(
  response: SimulateOrdersResponse,
): ResultSimulationForOption1Model[] {
  console.log(response)
  return response.outputs.map((output) => {
    return {
      relationNumber:
        output.relationNumber === 0 ? '-' : output.relationNumber.toString(),
      orderRelationString:
        output.orders.length > 0
          ? output.orders.map((order) => order.orderNumber).join(',')
          : '-',
      allowDeal: output.checkCreditRiskResults?.overallAllowed ?? false,
      allowDealStatus:
        output.checkCreditRiskResults?.overallAllowed !== undefined
          ? output.checkCreditRiskResults.overallAllowed
            ? create(StatusLabelSchema, {
                status: StatusLabel_Status.POSITIVE,
                label: t('domain:model.deal.deal_available.available'),
              })
            : create(StatusLabelSchema, {
                status: StatusLabel_Status.NEGATIVE,
                label: t('domain:model.deal.deal_available.unavailable'),
              })
          : create(StatusLabelSchema, {
              status: StatusLabel_Status.UNSPECIFIED,
              label: '-',
            }),
      requiredMarginAmount:
        output.checkCreditRiskResults?.maxRequiredMargin !== undefined
          ? output.checkCreditRiskResults.maxRequiredMargin.toLocaleString()
          : '-',
      surplusAmount:
        output.checkCreditRiskResults?.surplusAmount !== undefined
          ? output.checkCreditRiskResults.surplusAmount.toLocaleString()
          : '-',
      collateralAmount:
        output.checkCreditRiskResults?.collateralAmount !== undefined
          ? output.checkCreditRiskResults.collateralAmount.toLocaleString()
          : '-',
      totalCreditAmount:
        output.checkCreditRiskResults?.maxLimitAmount !== undefined
          ? output.checkCreditRiskResults.maxLimitAmount.toLocaleString()
          : '-',
    }
  })
}
